import React, { ReactElement, useCallback } from 'react';
import ShareIcon from '@westwing/ui-kit/Icons/Share';
import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { generateWWEvents } from '../WWEvents';
import { useHeaderContext } from 'Components/HeaderContext';

const StyledIconButton = styled.button`
    width: 48px;
    height: 48px;
    display: grid;
    place-items: center;
    transition: 0.3s ease-out box-shadow;
    box-shadow: inset 0 0 0 0 currentColor;

    &:focus-visible {
        box-shadow: inset 0 0 0 2px currentColor;
    }

    ${forTablet`
        display: none;
    `}
`;

const Share = (): ReactElement => {
    const { t } = useHeaderContext();
    const {
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
        },
    } = useHeaderContext();

    const onShareIconClick = useCallback(() => {
        const WWEvents = generateWWEvents();
        WWEvents.fire('SHARE_MODAL_OPEN', undefined);
        trackNonInteractiveGenericEvent('PDP', { action: 'Sharing feature - Click' });
    }, [trackNonInteractiveGenericEvent]);

    return (
        <StyledIconButton
            data-testid="oww-header-share-icon"
            onClick={onShareIconClick}
            aria-label={t('OwwHeader_Share with your friends')}
        >
            <ShareIcon />
        </StyledIconButton>
    );
};

export default Share;
